import { flush, setTransport } from '@amplitude/analytics-browser';

const BEACON_FLUSH_TIMEOUT_MS = 500;

/**
 * Flush queued Amplitude events via `sendBeacon` so a "clicked" event survives the
 * navigation that follows — the default batched `fetch` transport gets cancelled on
 * unload (esp. cross-origin). Call before navigating; redirect in `.finally()`.
 */
export const flushAmplitudeViaBeacon = async (): Promise<void> => {
    try {
        setTransport('beacon');
        await Promise.race([
            flush().promise,
            new Promise<void>((resolve) => setTimeout(resolve, BEACON_FLUSH_TIMEOUT_MS))
        ]);
    } catch {
        // don't let a flush failure block navigation
    } finally {
        setTransport('fetch');
    }
};
